// extracted by mini-css-extract-plugin
export default {"chart":"Chart_chart__iuU1+","xAxisTickLabel":"Chart_xAxisTickLabel__JSoSx","tooltipWrapper":"Chart_tooltipWrapper__ARUqb","keyIndicator":"Chart_keyIndicator__BF6+q"};